import 'jquery';
import 'bootstrap';

$(window).on('load', () => {
    const csrfToken = $("meta[name='_csrf_token']").attr("content");
    const csrfParameter = $("meta[name='_csrf_parameter']").attr("content");
    // const csrfHeader = $("meta[name='_csrf_header']").attr("content");

    $(document).on('click', 'a.csrf-protected', (e: JQueryEventObject) => {
        e.preventDefault();
        let $a = $(e.target);
        if (!$a.is("a[href]")) {
            $a = $a.closest("a.csrf-protected[href]");
        }

        let confirmText = $a.data('csrf-confirm');
        if (confirmText && !confirm(confirmText)) {
            return; // cancel
        }

        console.log('Submitting csrf-protected action as a POST request to ' + $a.attr('href'), $a);

        let $form = $('<form style="display:none" method="post"></form>').attr('action', $a.attr('href'));
        $form.append($('<input type="hidden">').attr("name", csrfParameter).val(csrfToken));
        $form.append($('<input type="submit">'));
        $('body').append($form);

        $form.submit();
    });

    $('.modal.visible').modal({
        show: true,
        focus: true
    });

});
